// ThemeContext.js
import React, { createContext, useContext, useState,useRef } from 'react';

const Summary = createContext();

export const SummaryProvider = ({ children }) => {
  const [showReport, setShowReport] = useState(false);
  const [showMainPanel, setMainContent] = useState(true);
  const SelectedLayersFeaturesDetailsRef = useRef([]);
  const [activeTab, setActiveTab] = useState("Search");
  const [treeRoot, setTreeRoot] = useState([]);
  const [lineChartOptions1, setLineChartOptions1] = useState({});
  const [CHlineChartOptions1, setCHLineChartOptions1] = useState({});
  const [SHlineChartOptions1, setSHLineChartOptions1] = useState({});
  const [SensitiveHabitatRows, setSensitiveHabitatRows] = React.useState([]);
  const [criticalHabitatRows, setCriticalHabitatRows] = React.useState([]);
  const [GroundWaterWellRows, setGroundWaterWellRows] = useState([]);
  const [GroundWaterlevelRows, setGroundWaterlevelRows] = useState([]);
  const [HabitatRows, setHabitatRows] = React.useState([]);
  const [drawtool, setDrawtool] = useState({});
  const [GroundWatersalinityRows, setGroundWatersalinityRows] = useState([]);
  const [DepletedDataRows, setDepletedDataRows] = useState([]);
  const [geometry, setGeometry] = useState(null)
  const [activeMainTab, setActiveMainTab] = useState([]);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const [Filename, setFileNAme] = useState("");
  const [ExportAll, setExportAll] = useState(false);
  const [ExportShapefile, setExportShapefile] = useState(null);
  const [ExportPDF, setExportPDF] = useState(false);
  const sketchRef = useRef(null);
  const [unit, setUnit] = useState("meters");
  const [distance, setDistance] = useState("100");
  const [selectUpload, setselectUpload] = useState("");
  const [file, setFile] = useState("shape");
  const [geojsonData, setGeojsonData] = useState(null);
  const [UploadedGeom, setUploadedGeom] = useState(null);
  const selectedFileRef = useRef(null);
  const [viewonlyFeatures, setViewonlyFeatures] = React.useState(false);
  let totalCriticalHabitatArea = 0;
  let totalSensitiveHabitatArea = 0;
  var totalhabitatMapArea = 0
  let criticalHabitatArea = {};
  let sensitiveHabitatArea = {};
  var criticalHabitatsCount = {};
  var habitatMapArea = {}
  var criticalHabitatType = {};
  var sensitiveHabitatType = {};
  const [ForestDatarow, setForestDatarow] = useState([]);
  const [AvianDataRow, setAvianDataRow] = useState([]);
  const [ProtectedDataRow, setProtectedDataRow] = useState([]);
  const [MPADataRow, setMPADataRow] = useState([]);
  const [turtelDataRow, setTurtleDatarow] = useState([]);
  const [DolphinDataRow, setDolphinDataRow] = useState([]);
  const [DugongDataRow, setDugongDataRow] = useState([]);
  return (
    <Summary.Provider value={{
      unit, setUnit,
      distance, setDistance,
      selectUpload, setselectUpload,
      file, setFile,
      selectedFileRef,
      UploadedGeom, setUploadedGeom,
      geojsonData, setGeojsonData,
      sketchRef,
      activeMainTab, setActiveMainTab,
      ExportPDF, setExportPDF,
      ExportShapefile, setExportShapefile,
      ExportAll, setExportAll,
      scriptLoaded, setScriptLoaded,
      selectedArea, setSelectedArea,
      Filename, setFileNAme,
      geometry, setGeometry,
      HabitatRows, setHabitatRows,
      DepletedDataRows, setDepletedDataRows,
      drawtool, setDrawtool,GroundWatersalinityRows, setGroundWatersalinityRows,
      GroundWaterlevelRows, setGroundWaterlevelRows,
      GroundWaterWellRows, setGroundWaterWellRows,
      SensitiveHabitatRows, setSensitiveHabitatRows,
      criticalHabitatRows, setCriticalHabitatRows,
      lineChartOptions1, setLineChartOptions1,
      CHlineChartOptions1, setCHLineChartOptions1,
      SHlineChartOptions1, setSHLineChartOptions1,
      activeTab, setActiveTab,
      showReport, setShowReport,showMainPanel,
       setMainContent,SelectedLayersFeaturesDetailsRef,
       activeTab, setActiveTab,
       totalCriticalHabitatArea,
       totalhabitatMapArea,
       treeRoot, setTreeRoot,
       totalSensitiveHabitatArea,
       criticalHabitatArea,sensitiveHabitatArea,
       criticalHabitatsCount,habitatMapArea,criticalHabitatType,sensitiveHabitatType,
       viewonlyFeatures, setViewonlyFeatures,
       setForestDatarow, ForestDatarow, setAvianDataRow, AvianDataRow, 
       setProtectedDataRow, setMPADataRow, MPADataRow, ProtectedDataRow,
       DugongDataRow, setDugongDataRow, turtelDataRow, setTurtleDatarow, DolphinDataRow, setDolphinDataRow,
       }}>
      {children}
    </Summary.Provider>
  );
};

// Custom hook for convenience
export const useSummary = () => useContext(Summary);
